// extracted by mini-css-extract-plugin
export default {"title":"ImagePreview_title__LBYUI","valueWrapper":"ImagePreview_valueWrapper__VUwgF","imageProperties":"ImagePreview_imageProperties__CEoDZ","image":"ImagePreview_image__PvNt5"};